module.exports = __webpack_public_path__ + "img/zhuban.dbbd4e08.png";